module.exports = __webpack_public_path__ + "img/ht.8994afd9.jpeg";